export const truncateWithEllipsis = (
  text: string | undefined,
  characterCount: number
) => {
  if (!text) return "";
  if (text.length <= characterCount) {
    return text;
  } else {
    return text.slice(0, characterCount - 1) + "...";
  }
};
